
const report = {
    create(message: string, error: Error, data: any): void {
        console.error('Error report not implemented yet', message, error, data)
    }
}
export default report
